import { accessTokenSignal } from "@src/auth/auth-utils";
import { shouldUseDesktopBrowserLogin } from "@src/auth/desktop-browser-login";
import { DesktopSignedOutScreen } from "@src/auth/desktop-signed-out-screen";
import { DesktopProfileEffects, DesktopProfilesProvider } from "@src/desktop";
import { memo } from "react";
import { useLoaderData } from "react-router-dom";
import { UserProvider } from "../user/user-provider";
import { AuthenticatedLayout } from "./authenticated-layout";

/**
 * The main layout exists to provide access to both authenticated users and
 * share key users.
 *
 * `AuthenticationGuard` is used to protect the authenticated routes. If the user
 * is not authenticated, they are redirected to the login.
 *
 * If the user has a share key, the empty layout is rendered which doesn't include
 * any protected queries or mutations.
 */
export const MainLayout = memo(() => {
	const { isAuthenticated, user, skipAuth } = useLoaderData();
	const hasActiveToken = accessTokenSignal.value !== null;

	// the loader will render this component even if it's in the process of kicking the user out
	// this is here to prevent the user seeing errors from loading authenticated content without auth
	if ((!isAuthenticated || !hasActiveToken) && !skipAuth) {
		if (shouldUseDesktopBrowserLogin()) {
			return <DesktopSignedOutScreen />;
		}
		return null;
	}

	return (
		<UserProvider user={user}>
			<DesktopProfilesProvider>
				<DesktopProfileEffects />
				<AuthenticatedLayout key={"authenticated-layout"} />
			</DesktopProfilesProvider>
		</UserProvider>
	);
});
